import React from 'react';
import { BaasicMessagesTemplate } from 'themes/components';
import { useStores } from 'core/stores/StoreContext';

const BaasicMessages = (props) => {
    const { viewStore, baasicMessageStore } = useStores();
    return <BaasicMessagesTemplate {...props} viewStore={viewStore} baasicMessageStore={baasicMessageStore} />;
};

export default BaasicMessages;
